exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".launcher {\n  display: grid;\n  grid-gap: calc(var(--gap) * 0.75);\n  grid-template-columns: repeat(auto-fit, 88px);\n  justify-content: center;\n}", ""]);

// exports
